import React, { useEffect, useMemo, useState } from "react";
import { Select, Spin } from "antd";
import type { SelectProps } from "antd";
import debounce from "lodash/debounce";
import { getCustomers } from "../service";
import UserTag from "./userTag";
import { colorHash } from "lib/utils";
import "./style.scss";
export interface DebounceSelectProps
  extends Omit<SelectProps<any | any[]>, "options" | "children"> {
  fetchOptions: (search: string) => Promise<any[]>;
  debounceTimeout?: number;
  selectRef?: React.Ref<any>;
}

function DebounceSelect({
  fetchOptions,
  debounceTimeout = 200,
  ...props
}: DebounceSelectProps) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState<any[]>([]);

  const debounceFetcher = useMemo(() => {
    const loadOptions = (value: string) => {
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        setOptions(newOptions);
        setFetching(false);
      });
    };

    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);
  useEffect(() => {
    debounceFetcher();
  }, []);
  return (
    <Select
      className="userSelect"
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      ref={props.selectRef}
      options={options}
      labelRender={(label) => {
        return label.label; //<UserTag userName={label.label} />;
      }}
      optionRender={(option) => {
        return (
          <div
            style={{
              height: "67px",
              maxWidth: "280px",
              display: "flex",
              flexDirection: "row",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: "20%",
                height: "100%",
                alignContent: "center",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "80px",
                  backgroundColor: colorHash.hex(option.data.email || ""),
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "20px",
                  color: "white",
                }}
              >
                {option.data.label.substr(0, 1)}
              </div>
            </div>
            <div
              style={{
                width: "80%",
                height: "100%",
                display: "flex",
                justifyContent: "space-around",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <div style={{ fontSize: "16px", fontWeight: 400 }}>
                {option.data.label || ""}
              </div>
              <div
                style={{
                  width: "100%",
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#717171",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
                title={option.data.email || "(email unavailable)"}
              >
                {option.data.email || "(email unavailable)"}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#717171",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
                title={option.data.phone || "(phone number unavailable)"}
              >
                {option.data.phone || "(phone number unavailable)"}
              </div>
            </div>
          </div>
        );
      }}
    />
  );
}

// Usage of DebounceSelect
interface UserValue {
  label: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  value: string;
}

const UserSelect = ({
  onChange,
  value,
  maxSelectNumber,
  formatter,
  ...props
}) => {
  async function fetchUserList(username: string): Promise<UserValue[]> {
    console.log("fetching user", username);
    return getCustomers(username).then((data: any) => {
      const userList = data?.data?.data;
      return userList?.map((item) => ({
        label: item.customer.accountName,
        firstName: item.customer.user.firstName,
        lastName: item.customer.user.lastName,
        email: item.customer.user.email,
        phone: item.customer.user.phoneNumber,
        value: item.customer.orgId,
      }));
    });
  }
  return (
    <DebounceSelect
      mode="multiple"
      maxCount={maxSelectNumber}
      selectRef={props.selectRef}
      value={formatter(value)}
      placeholder="Select users"
      fetchOptions={fetchUserList}
      onChange={onChange}
      style={{ width: "100%" }}
      {...props}
    />
  );
};

export default UserSelect;
